import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepBaggageAndPersonalItemsStarr = (state) => state.get('stepBaggageAndPersonalItemsStarr');

const makeSelectStepBaggageAndPersonalItemsStarr = () => createSelector(
  selectStepBaggageAndPersonalItemsStarr,
  (stepBaggageAndPersonalItemsStarrState) => ({

    // Damaged Lost
    areYouClaimingForDamagedLostOrStolenLuggage: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'areYouClaimingForDamagedLostOrStolenLuggage']),
      ''
    ),
    areYouClaimingFor1: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'areYouClaimingFor1']),
      ''
    ),
    companyYouWereTravelingWith: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'companyYouWereTravelingWith']),
      ''
    ),
    areYouClaimingFor2: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'areYouClaimingFor2']),
      ''
    ),
    originForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'originForDamaged']),
      ''
    ),
    destinationForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'destinationForDamaged']),
      ''
    ),
    areYouClaimingFor3: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'areYouClaimingFor3']),
      ''
    ),
    ifOtherPleaseDescribeWhere: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'ifOtherPleaseDescribeWhere']),
      ''
    ),
    whoDidYouReportTo: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'whoDidYouReportTo']),
      ''
    ),
    ifOtherPleaseDescribe2: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'ifOtherPleaseDescribe2']),
      ''
    ),
    reportReferenceNumber: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'reportReferenceNumber']),
      ''
    ),
    // Baggage Delay
    areYouClaimingForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'areYouClaimingForBaggageDelay']),
      ''
    ),
    companyBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'companyBaggageDelay']),
      ''
    ),
    travelSupplierInformation: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'travelSupplierInformation']),
      ''
    ),
    originForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'originForBaggageDelay']),
      ''
    ),
    destinationForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'destinationForBaggageDelay']),
      ''
    ),
    dateWhenYourLuggageWasDelayed: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'dateWhenYourLuggageWasDelayed']),
      ''
    ),
    timeWhenYourLuggageWasDelayed: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'timeWhenYourLuggageWasDelayed']),
      ''
    ),
    dateWhenYourLuggageWasReturned: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'dateWhenYourLuggageWasReturned']),
      ''
    ),
    timeWhenYourLuggageWasReturned: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'timeWhenYourLuggageWasReturned']),
      ''
    ),
    haveYouMadeAClaimWithYourTravelProvider: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'haveYouMadeAClaimWithYourTravelProvider']),
      ''
    ),
    // airlineFlinhtNumberForDamaged: mapWithDefault(
    //   stepBaggageAndPersonalItemsStarrState,
    //   () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'airlineFlinhtNumberForDamaged']),
    //   ''
    // ),

    // airlineAirCarrierForDamaged: mapWithDefault(
    //   stepBaggageAndPersonalItemsStarrState,
    //   () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'airlineAirCarrierForDamaged']),
    //   ''
    // ),

    reportDate: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'reportDate']),
      ''
    ),

    organizationNameReportedTo: mapWithDefault(
      stepBaggageAndPersonalItemsStarrState,
      () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'organizationNameReportedTo']),
      ''
    ),

    // airlineFlinhtNumberForBaggageDelay: mapWithDefault(
    //   stepBaggageAndPersonalItemsStarrState,
    //   () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'airlineFlinhtNumberForBaggageDelay']),
    //   ''
    // ),

    // airlineDepartureDateForBaggageDelay: mapWithDefault(
    //   stepBaggageAndPersonalItemsStarrState,
    //   () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'airlineDepartureDateForBaggageDelay']),
    //   ''
    // ),

    // airlineAirCarrierForBaggageDelay: mapWithDefault(
    //   stepBaggageAndPersonalItemsStarrState,
    //   () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'airlineAirCarrierForBaggageDelay']),
    //   ''
    // ),

    descriptionOfItems: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'descriptionOfItems']) && stepBaggageAndPersonalItemsStarrState.getIn(['form', 'descriptionOfItems']).toJS(), ''),
    descriptionOfItemsForDamaged: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'descriptionOfItemsForDamaged']) && stepBaggageAndPersonalItemsStarrState.getIn(['form', 'descriptionOfItemsForDamaged']).toJS(), ''),
    //------------------------------------

    // Fight Aware API
    flightDetailsForBaggageDelay: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDetailsForBaggageDelay']) && stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDetailsForBaggageDelay']).toJS(), ''),
    flightNumberForBaggageDelay: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightNumberForBaggageDelay']), ''),
    flightDateForBaggageDelay: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDateForBaggageDelay']), ''),

    flightDetailsForDamaged: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDetailsForDamaged']) && stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDetailsForDamaged']).toJS(), ''),
    flightNumberForDamaged: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightNumberForDamaged']), ''),
    flightDateForDamaged: mapWithDefault(stepBaggageAndPersonalItemsStarrState, () => stepBaggageAndPersonalItemsStarrState.getIn(['form', 'flightDateForDamaged']), ''),
  })
);

const makeSelectStepBaggageAndPersonalItemsStarrErrors = () =>
  createSelector(selectStepBaggageAndPersonalItemsStarr, (state) => state.get('errors'));

export {
  makeSelectStepBaggageAndPersonalItemsStarr,
  makeSelectStepBaggageAndPersonalItemsStarrErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/selectors.js